















































import { Vue, Component, Prop } from "vue-property-decorator";
import {DateTime} from "luxon"
import {CustomersModel} from "@/model/customer.model";
import {CUSTOMERS_MODEL_STATUS} from "@/model/customer.model";
import CustomerCodeGuide from "@/component/mypage/customer-code-guide.vue";

const IMAGE_MAP = [
  { commercial: 'CP', image: "logo_cp.gif", imageClass: "img-cp" },
  { commercial: 'TK', image: "logo_tk.png", imageClass: "img-tk" },
  { commercial: 'MTM', image: "logo_mtm.png", imageClass: "img-mtm" },
  { commercial: 'BTS', image: "logo_bts.png", imageClass: "img-bts" },
];

@Component({
  components: {CustomerCodeGuide}
})
export default class CustomerCodeView extends Vue {
  @Prop() private model!: CustomersModel;
  showCustomerCodeGuideFlag:boolean = false;

  customerModelStatus() {
    return CUSTOMERS_MODEL_STATUS;
  }

  showGuide() {
    document.body.classList.add('modal-opened')
    this.showCustomerCodeGuideFlag = true;
  }

  formatLinkedDate(datestr: string) {
    return DateTime.fromISO(datestr, {zone: 'Asia/Tokyo'}).toFormat('yyyy年M月d日(ccc) HH:mm');
  }

  closeGuide() {
    document.body.classList.remove('modal-opened')
    this.showCustomerCodeGuideFlag = false;
  }

  imageFile(commercial: string) {
    const targetImage = IMAGE_MAP.find(m => m.commercial === commercial);
    return (targetImage) ? require(`@/asserts/${targetImage.image}`) : require('@/asserts/logo_default.png');
  }

  imageClass(commercial: string) {
    const targetImage = IMAGE_MAP.find(m => m.commercial === commercial);
    return (targetImage) ? targetImage.imageClass : 'img-default';
  }
}
